import { render, staticRenderFns } from "./Dateorderlistmodal.vue?vue&type=template&id=68c2bf04&scoped=true&"
import script from "./Dateorderlistmodal.vue?vue&type=script&lang=js&"
export * from "./Dateorderlistmodal.vue?vue&type=script&lang=js&"
import style0 from "./Dateorderlistmodal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dateorderlistmodal.vue?vue&type=style&index=1&id=68c2bf04&scoped=true&lang=css&"
import style2 from "./Dateorderlistmodal.vue?vue&type=style&index=2&id=68c2bf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2bf04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VChip,VContainer,VDataTable,VDialog,VFlex,VIcon,VImg,VLayout,VRow,VToolbar,VToolbarTitle})
